{
  "version": 1,
  "asset_id": "d099d17a-27ea-4162-9076-83e29028418e",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/d099d17a-27ea-4162-9076-83e29028418e/rv_electrical.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/d099d17a-27ea-4162-9076-83e29028418e/rv_electrical.webp",
  "original_filename": "rv_electrical.webp",
  "size": 30826,
  "content_type": "image/webp",
  "created_at": "2026-07-14T02:53:23Z"
}
